import React, { useCallback } from 'react';

import Input from '@xcritical/input';

import { ErrorWrapper } from '@crm-framework/form-fields/src/error-wrapper';
import { useRegistry } from '@crm-framework/registry';

import { ILeadPhoneData, LEAD_REGISTRY } from '@crm-lead/base';

import { PhoneContainerEditView } from '../styled';
import { IEditViewMultiInput } from '../types';

export const PureViewMultiInput: React.FC<IEditViewMultiInput> = ({
  value,
  onChange,
  invalid,
  phoneIndex,
  disabled,
}) => {
  const isMainFormLoading =
    useRegistry<boolean>(LEAD_REGISTRY.mainFormLoading, false) || disabled;

  const handleChange = useCallback(
    (v: string, n: keyof ILeadPhoneData, maxLength) => {
      if (v.length > maxLength) return;

      onChange({ ...value, [n]: v } as ILeadPhoneData);
    },
    [onChange, value]
  );

  const handleKeyPress = useCallback((e) => {
    const keyCode = e.keyCode || e.which;

    if (/[a-zA-Z]/.test(String.fromCharCode(keyCode))) {
      e.preventDefault();
    }
  }, []);

  return (
    <PhoneContainerEditView>
      <Input
        type="number"
        invalid={invalid}
        appearance="compact"
        id={`phone${phoneIndex}`}
        className={`personal-data-phone__country personal-data-phone--${phoneIndex}`}
        value={value?.country ?? ''}
        onChange={(v) => handleChange(v, 'country', 4)}
        disabled={isMainFormLoading}
      />
      <Input
        type="number"
        invalid={invalid}
        appearance="compact"
        className={`personal-data-phone__operator personal-data-phone--${phoneIndex}`}
        value={value?.operator ?? ''}
        onChange={(v) => handleChange(v, 'operator', 4)}
        disabled={isMainFormLoading}
      />
      <Input
        type="number"
        invalid={invalid}
        appearance="compact"
        className={`personal-data-phone__visiblePart personal-data-phone--${phoneIndex}`}
        value={value?.visiblePart ?? ''}
        onChange={(v) => handleChange(v, 'visiblePart', 20)}
        disabled={isMainFormLoading}
      />
      <Input
        onKeyPress={handleKeyPress}
        invalid={invalid}
        appearance="compact"
        className={`personal-data-phone__invisiblePart personal-data-phone--${phoneIndex}`}
        value={value?.invisiblePart ?? ''}
        onChange={(v) => handleChange(v, 'invisiblePart', 4)}
        disabled={isMainFormLoading}
      />
    </PhoneContainerEditView>
  );
};

export const EditViewMultiInput: React.FC<IEditViewMultiInput> = ({
  invalid,
  error,
  errorProps,
  disabled,
  ...rest
}) => {
  const wrapperProps = {
    appearance: 'error',
    errorMessage: error,
    position: errorProps ?? 'top left',
    withIcon: false,
  };

  return (
    <ErrorWrapper
      errorModeWithIcon={false}
      content={error}
      visible={!!error}
      iconPosition="left"
      {...wrapperProps}>
      <PureViewMultiInput {...rest} invalid={invalid} disabled={disabled} />
    </ErrorWrapper>
  );
};
